angular.module('charts')
  .service('dblStudentLoginCardReportService', [
        '$compile',
        '$http',
        '$q',
        '$rootScope',
        '$templateRequest',
        '$timeout',
        'dblPrintService',
    function(
        $compile,
        $http,
        $q,
        $rootScope,
        $templateRequest,
        $timeout,
        dblPrintService
    ) {

    var BASE_DIRECTORY = '/resources/charts/directives';
    var LOGIN_CARD_TEMPLATE_URL = BASE_DIRECTORY + '/student-login-card/dbl-student-login-card.directive.html';
    var LOGIN_CARD_REPORT_TEMPLATE_URL = BASE_DIRECTORY + '/student-login-card-report/dbl-student-login-card-report.directive.html';
    var INVOCATION_TEMPLATE = '<div>' +
        '<dbl-student-login-card-report ' +
            'dbl-classroom="item" ' +
            'dbl-login-code="loginCode" ' +
            'dbl-student-list="activatedStudents" ' +
            'dbl-student-login-url="studentLoginUrl" ' +
            'dbl-school-code="schoolCode" ' +
            'dbl-auth-is-text="authTypeIsText"></dbl-student-login-card-report>' +
        '</div>';

    var loginCardInitPromise;

    var initializeTemplates = function () {
        // This preloads directive templates and images so they are ready for generating the report.
        // Without it, login cards can come up empty or have missing images.
        // This will actually resolve before images are loaded so on slow connections the images still
        // may not be present. One way to make this solid would be to use $http to fetch the image
        // so you'd have a promise that resolves when the image is loaded, but that seems difficult
        // because we can't seem to easily get the cache busted name of the image here.
        return $q.all([
                $templateRequest(LOGIN_CARD_REPORT_TEMPLATE_URL),
                $templateRequest(LOGIN_CARD_TEMPLATE_URL)
            ]).then(function (templates) {
                var scope = $rootScope.$new();

                // this fetches images
                $compile(templates[1])(scope);

                scope.$destroy();

                return templates;
            });
    };

    this.init = function () {
        loginCardInitPromise = initializeTemplates();

        return loginCardInitPromise;
    };

    // scope should be an Angular scope object with the following properties:
    //   item - classroom object
    //   activatedStudents - student roster
    //   authTypeIsText
    //   schoolCode
    //   studentLoginUrl
    //   loginCode
    // See INVOCATION_TEMPLATE
    this.print = function (scope) {
        loginCardInitPromise.then(function () {
            var loginCardReportElement = $compile(INVOCATION_TEMPLATE)(scope);

            $timeout(function () {
                dblPrintService.printElement(loginCardReportElement);
            },150);
        });
    };

    this.newPrint = function (values) {
      var scope = $rootScope.$new();
      angular.merge(scope, values);
      this.print(scope);
    };

}]);
